var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"bg-fullpage mb-2"},[(_vm.showLayout)?_c('dashboard-core-app-bar'):_vm._e(),_c('dashboard-core-loadings'),(_vm.showLayout)?_c('dashboard-core-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }